// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "./index.css";
import FormView from "./App";
import Home from "./pages/Home";
import TestHome from "./pages/TestHome";
import {
  MechanicalTest,
  NumericTest,
  SpatialReasoningTest,
  VerbalTestApp,
  AbstractTestApp,
  PersonalityTest
} from "./pages/tests";
import Profile from "./pages/Profile";
import ScholarshipSearch from "./pages/ScholarshipSearch";
import Login from "./pages/Login"; // optional login page if you want a custom login view
import ProtectedRoute from "./pages/ProtectedRoute";
import AdminRoute from "./pages/AdminRoute";
import Admin from "./pages/Admin";
import { Auth0Provider } from "@auth0/auth0-react";
import About from "./pages/About";
import GlobalAuthEffects from "./components/GlobalAuthEffects";

// Auth0 config — values come from .env (VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID, VITE_AUTH0_AUDIENCE)
// The custom domain (e.g. login.uni-match.io) is set via VITE_AUTH0_DOMAIN.
// VITE_AUTH0_AUDIENCE must remain the default Auth0 tenant URL — not the custom domain —
// because the Management API audience is bound to the original tenant identifier.
const domain = import.meta.env.VITE_AUTH0_DOMAIN as string;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE as string;

const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    navigate(appState?.returnTo ?? "/login", { replace: true });
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
    <Auth0ProviderWithNavigate>
        <GlobalAuthEffects />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route
            path="/about"
            element={
              <ProtectedRoute>
                <About />
              </ProtectedRoute>
            }
          />
          <Route
            path="/career_recommender"
            element={
              <ProtectedRoute>
                <FormView />  
              </ProtectedRoute>
            }
          />
          <Route
            path="/verbal_test"
            element={  
                <VerbalTestApp />
            }
          />
          <Route
            path="/numerical_test"
            element={
                <NumericTest />
            }
          />
          <Route
            path="/mechanical_test"
            element={
                <MechanicalTest />
            }
          />
          <Route
            path="/spatial_test"
            element={
                <SpatialReasoningTest />
            }
          />
          <Route
            path="/abstract_test"
            element={
                <AbstractTestApp />
            }
          />
          <Route
            path="/personality_test"
            element={
                <PersonalityTest />
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />  
              </ProtectedRoute>
            }
          />
          <Route
            path="/scholarship_search"
            element={
                <ScholarshipSearch />
            }
          />
          <Route
            path="/test_home"
            element={
              <ProtectedRoute>
                <TestHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            }
          />
          {/* Add more routes as needed */}
        </Routes>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
  </React.StrictMode>
);
